import Image, { StaticImageData } from "next/image";
import TitleH2 from "./fonts/TitleH2";
import MainLink from "./navigation/MainLink";

interface FeatureHighlightProps {
  src: StaticImageData | string;
  alt: string;
  title: string;
  text: string;
  subText?: string;
  subText2?: string;
  list?: string[];
  link?: boolean;
  linkTitle?: string;
  href?: string;
  className?: string;
}

const FeatureHighlight = ({ ...props }: FeatureHighlightProps) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="xs:flex-row flex flex-col items-center gap-6">
        <Image src={props.src} alt={props.alt} width={100} height={100} />
        <TitleH2 title={props.title} />
      </div>
      <div className={`text-ring flex flex-col gap-3 ${props.className}`}>
        {props.text && <span>{props.text}</span>}
        {props.subText && <span>{props.subText}</span>}
        {props.subText2 && <span>{props.subText2}</span>}
      </div>
      {props.list && (
        <ul className="marker:text-primary marker:text-xxl text-ring flex list-disc flex-col justify-center gap-4 pl-6">
          {props.list.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      )}
      {props.link && (
        <div className="flex items-center">
          <MainLink href={props.href ?? ""} title={props.linkTitle ?? ""} />
        </div>
      )}
    </div>
  );
};

export default FeatureHighlight;
